import React, {useEffect, useState} from "react";
import {Routes, Route, Navigate, useLocation} from "react-router-dom";
import DashboardSidebar from "../components/dashboard/DashboardSidebar";
// import DashboardHeader from '../components/dashboard/DashboardHeader';
import DashboardHeader from "../components/admin/DashboardHeader";
import DashboardHome from "../components/dashboard/DashboardHome";
import MyRatings from "../components/dashboard/MyRatings";
import SubmitRating from "../components/dashboard/SubmitRating";
import MyComments from "../components/dashboard/MyComments";
import MyReplies from "../components/dashboard/MyReplies";
import MyLikes from "../components/dashboard/MyLikes";
import MyUplifts from "../components/dashboard/MyUplifts";
import MyFlagged from "../components/dashboard/MyFlagged";
import SubmitComment from "../components/dashboard/SubmitComment";
import Feedback from "../components/dashboard/Feedback";
import MyActivity from "../components/dashboard/MyActivity";

import Notifications from "../components/dashboard/Notifications";
import CommentHistory from "../components/dashboard/CommentHistory";

import MyProfile from "./MyProfile";
import BusinessVerifiedPage from "../pages/BusinessVerifiedPage";
import {GetBusinessVerifiedService} from "../services/authUpdate";

const ContractorDashboard = () => {
	const location = useLocation();

	const [sidebarOpen, setSidebarOpen] = useState(false);
	const [isDisable, setIsDisable] = useState(true);

	const toggleSidebar = () => {
		setSidebarOpen(!sidebarOpen);
	};

	const getAction = async () => {
		const response = await GetBusinessVerifiedService();

		if (response.status) {
			const isContractor = response.data.role === "contractor";
			const isVerified = Boolean(response?.data?.verified);
			const trusted = Boolean(response?.data?.trusted);

			const shouldDisableNav = response.data.role === "contractor" && !response?.data?.verified;

			setIsDisable(shouldDisableNav);

			if (isContractor && !isVerified && location.pathname !== "/contractor-dashboard/business-verified") {
				window.location.href = "/contractor-dashboard/business-verified";
				return;
			} else {
				localStorage.setItem("verified", isVerified);
				localStorage.setItem("trusted", trusted);
			}
		}
	};

	useEffect(() => {
		const token = localStorage.getItem("auth_token");
		if (!token) return;
		getAction();
	}, [location.pathname]);

	return (
		<div className="dashboard-container">
			<DashboardSidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} isDisable={isDisable} />
			<div className={`dashboard-main ${sidebarOpen ? "sidebar-open" : ""}`}>
				<DashboardHeader toggleSidebar={toggleSidebar} isDisable={isDisable} />
				<div className="dashboard-content">
					<Routes>
						<Route path="/" element={<DashboardHome />} />
						<Route path="/ratings" element={<MyRatings />} />
						<Route path="/submit-rating" element={<SubmitRating />} />
						<Route path="/comments" element={<MyComments />} />
						<Route path="/my-replies" element={<MyReplies />} />
						<Route path="/likes" element={<MyLikes />} />
						<Route path="/uplifts" element={<MyUplifts />} />
						<Route path="/flagged" element={<MyFlagged />} />
						<Route path="/submit-comment" element={<SubmitComment />} />
						<Route path="/feedback" element={<Feedback />} />
						<Route path="/my-profile" element={<MyProfile />} />

						<Route path="/activity" element={<MyActivity />} />
						<Route path="/notifications" element={<Notifications />} />
						<Route path="/comment-history" element={<CommentHistory />} />
						<Route path="/business-verified" element={<BusinessVerifiedPage />} />
						<Route path="*" element={<Navigate to="/contractor-dashboard/" replace />} />
					</Routes>
				</div>
			</div>
		</div>
	);
};

export default ContractorDashboard;
